import { FlatList, ScrollView, View } from "react-native";
import parse from "html-react-parser";
import LabelContainer from "../SettingsComponent/labelContainer";
import Separator from "../Separator";
import ComponentTypeEnum from "../../models/ComponentTypeEnum";
import { spacing_s } from "../../StyleHelpers";
import TouchableOpacity from "../TouchableOpacity/TouchableOpacity";
import { useNavigation } from "@react-navigation/native";
import { routeTitleDetails, TitleDetailsScreenNavigationProp } from "../../Routes";
import useGenericContentStore from "../../store/genericContent.store";
import { Pages } from "../../Types";
import { Container, Content, Main, Text } from "./styled";
import { Props } from "./model";

const tempText = "";

const PrivacyPolicy = (props: Props) => {
	const navigationTitleScreen = useNavigation<TitleDetailsScreenNavigationProp>();
	const setNavigateEvent = useGenericContentStore((state: any) => state.setNavigateEvent);
	const { isNarrow } = useGenericContentStore((state) => ({ isNarrow: state.isNarrow }));

	/**
	 * Handles navigation to the TitleDetails screen
	 * for a given transaction's parentProductId.
	 */
	const onPress = (parentProductId: number) => {
		setNavigateEvent(Pages.transactions);
		navigationTitleScreen.navigate(routeTitleDetails, { parentProductId });
	};

	/**
	 * Renders a single item in the FlatList for transaction history.
	 * Each item is wrapped in a TouchableOpacity to navigate when pressed.
	 * Includes a label container displaying the title and details,
	 * followed by a separator to visually distinguish between items.
	 */
	const renderItem = ({ item }: any) => (
		<>
			<TouchableOpacity style={{ marginBottom: spacing_s, paddingTop: spacing_s }} onPress={() => onPress(item.parentProductId)}>
				<View style={{ marginBottom: 7 }}>
					<LabelContainer addMarginChild={true} header={item.title} body={item.details} />
				</View>
			</TouchableOpacity>
			<Separator type={ComponentTypeEnum.Secondary} />
		</>
	);

	return (
		// @ts-ignore
		<Main>
			{/* @ts-ignore */}
			<Container narrow={isNarrow}>
				{/* @ts-ignore */}
				<Content>
					{props.text ? (
						// @ts-ignore
						<ScrollView style={{ paddingTop: isNarrow ? "1.5rem" : "7rem", paddingBottom: isNarrow ? "2rem" : "5rem" }}>
							{/* @ts-ignore */}
							<Text narrow={isNarrow}>{parse(props.text.replace(/<a[^>]*>(.*?)/gi, "").replace("</a>", "")) || tempText}</Text>
						</ScrollView>
					) : (
						<></>
					)}

					{props.transactionHistory ? (
						<ScrollView
							style={{
								flex: 1,
								width: "100%",
								paddingTop: isNarrow ? "1.5rem" : "7rem",
								paddingBottom: "5rem",
							}}
						>
							<FlatList
								keyExtractor={(item) => item.parentProductId}
								data={props.transactionHistory}
								extraData={props.transactionHistory}
								renderItem={renderItem}
								showsVerticalScrollIndicator={false}
								showsHorizontalScrollIndicator={false}
							/>
						</ScrollView>
					) : (
						<></>
					)}
				</Content>
			</Container>
		</Main>
	);
};

export default PrivacyPolicy;
